import {
  getCurrentPromoCode,
  addPromoCode,
  getPromotions,
  getCurrentPromotion,
  getAddPromotion,
  getRemovePromotion,
  removeCurrentPromoCode,
  gettingRedeemCodeCorrectless,
} from '@/utils/api';
import Vue from 'vue';
import Vuex from 'vuex';
import { getField, updateField } from 'vuex-map-fields';
import i18n from '@/utils/i18n';

Vue.use(Vuex);

const getDefaultState = () => {
  return {
    promoCode: '',
    promotions: [],
    currentPromoCode: {},
    currentPromotion: '',
    currentPromoCodeAppliedAlready: false,
    currentState: 'CLAIM_CHOOSE', // CLAIM_CHOOSE | CLAIM_YES | CLAIM_NO
    addPromoCodeStatus: {
      loading: false,
      success: false,
      error: false,
    },
    getPromoCodeStatus: {
      loading: false,
      success: false,
      error: false,
    },
    getPromotionsStatus: {
      loading: false,
      success: false,
      error: false,
    },
  };
};
const state = getDefaultState();

const getters = {
  getField,
};

const mutations = {
  setPromoCode: (state, code) => {
    state.promoCode = code;
  },
  updateField,
  setCurrentPromoCode(state, promoCode) {
    state.currentPromoCode = promoCode;
  },
  setCurrentPromotion(state, promotion) {
    state.currentPromotion = promotion;
  },
  setCurrentState(state, val) {
    state.currentState = val;
  },
  setCurrentPromoCodeAppliedAlready(state, val) {
    state.currentPromoCodeAppliedAlready = val;
  },
  setAddPromoCodeStatus(state, row) {
    state.addPromoCodeStatus = {
      ...state.addPromoCodeStatus,
      ...row,
    };
  },
  setGetPromoCodeStatus(state, row) {
    state.getPromoCodeStatus = {
      ...state.getPromoCodeStatus,
      ...row,
    };
  },
  setGetPromotionsStatus(state, row) {
    state.getPromotionsStatus = {
      ...state.getPromotionsStatus,
      ...row,
    };
  },
  setPromotions(state, arr) {
    state.promotions = arr;
  },
  resetClaimBonusState(state) {
    Object.assign(state, getDefaultState());
  },
};

const actions = {
  setPromoCode({ commit }, code) {
    commit('setPromoCode', code);
    console.log('kaydedildi', code);
  },
  async checkingRedeemCode(context, item = {}) {
    const {
      data: { Data: isValid, ExceptionMessage: error },
    } = await gettingRedeemCodeCorrectless(item);
    return { isValid, error };
  },
  tryGetPromotions({ commit }) {
    commit('setGetPromotionsStatus', { loading: true });
    getPromotions().then(r => {
      if (r.data.IsSuccess) {
        const d = r.data.Data.data.map(m => {
          let splitted = m.Description.split(' | ');
          m.FirstText = splitted[0];
          m.SecondaryText = splitted[1];
          return m;
        }, []);
        commit('setPromotions', d);
      }
      commit('setGetPromotionsStatus', { loading: false });
    });
  },
  tryGetCurrentPromotion({ commit }) {
    commit('setGetPromotionsStatus', { loading: true });
    return new Promise(resolve => {
      getCurrentPromotion().then(r => {
        if (r.data.IsSuccess) {
          if (r.data.Data.status === 'ok') {
            commit('setCurrentPromotion', r.data.Data.data.PromoCode);
          }
        }
        resolve();
        // commit("setCurrentPromotion", "MYB100")
        commit('setGetPromotionsStatus', { loading: false });
      });
    });
  },
  tryGetAddPromotion({ commit, dispatch }, promotion) {
    commit('setGetPromotionsStatus', { loading: true });
    return new Promise((resolve, reject) => {
      getAddPromotion(promotion).then(r => {
        if (r.data.IsSuccess) {
          if (r.data.Data.status === 'ok') {
            setTimeout(function() {
              dispatch('player/tryGetBalance', null, { root: true });
            }, 5000);
            dispatch('player/tryGetBalance', null, { root: true });
            commit('setCurrentPromotion', r.data.Data.data.Transaction.PromoCode);
            resolve();
          } else {
            reject(r.data.Data.error);
          }
        } else {
          reject(r.data.ExceptionMessage[0]);
        }
        // commit("setCurrentPromotion", promotion)
        commit('setGetPromotionsStatus', { loading: false });
      });
    });
  },
  tryGetRemovePromotion({ commit }) {
    commit('setGetPromotionsStatus', { loading: true });
    getRemovePromotion().then(r => {
      if (r.data.IsSuccess) {
        commit('setCurrentPromotion', '');
      }
      commit('setGetPromotionsStatus', { loading: false });
    });
  },

  tryGetPromoCode({ commit }) {
    commit('setGetPromoCodeStatus', { loading: true });
    getCurrentPromoCode().then(r => {
      if (r.data.IsSuccess) {
        const innerResponse = r.data.Data;
        if (innerResponse.status === 'fail') {
          commit('setCurrentPromoCode', {});
        }
        if (innerResponse.status === 'ok') {
          commit('setCurrentPromoCode', innerResponse.data);
          commit('setCurrentPromoCodeAppliedAlready', true);
        }
        commit('setCurrentState', 'CLAIM_YES');
      }
      commit('setGetPromoCodeStatus', { loading: false });
    });
  },
  tryAddPromoCode({ commit, dispatch }, promoCode) {
    commit('setAddPromoCodeStatus', { loading: true });
    addPromoCode(promoCode).then(r => {
      if (r.data.IsSuccess) {
        if (r.data.Data && r.data.Data.status === 'fail') {
          commit('setAddPromoCodeStatus', {
            success: false,
            error: i18n.t('Exceptions.' + r.data.Data.error.replace('promo ', 'promo-')),
          });
        } else {
          commit('setAddPromoCodeStatus', { success: true, error: false });
          dispatch('tryGetPromoCode');
        }
      }
      commit('setAddPromoCodeStatus', { loading: false });
      setTimeout(function() {
        dispatch('player/tryGetBalance', null, { root: true });
      }, 5000);
      dispatch('player/tryGetBalance', null, { root: true });
    });
  },
  tryRemoveCurrentPromoCode({ commit, dispatch }) {
    removeCurrentPromoCode().then(r => {
      if (r.data.IsSuccess) {
        dispatch('tryGetPromoCode');
        commit('setCurrentPromoCodeAppliedAlready', false);
      }
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
